'use client';

import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS, Node } from '@contentful/rich-text-types';
import { RichTextTableProps } from 'libs/contentful/props';
import { renderTable } from './nodes/Table';
import { renderTableRow } from './nodes/TableRow';
import renderEmbeddedEntry from '../../nodes/EmbeddedEntry';
import { useDisclosureNumberingMap } from 'contexts/DisclosureProvider';

const RichTextTable = ({ content, color }: RichTextTableProps) => {
  const disclosureNumberingMap = useDisclosureNumberingMap();

  const options = {
    renderNode: {
      [BLOCKS.TABLE]: (node: Node, children: React.ReactNode) => renderTable(node, children, color),
      [BLOCKS.TABLE_ROW]: renderTableRow,
      [INLINES.EMBEDDED_ENTRY]: (node: Node, children: React.ReactNode) =>
        renderEmbeddedEntry(node, children, content, disclosureNumberingMap),
    },
    renderMark: {
      [MARKS.ITALIC]: (text: React.ReactNode) => <span className="block text-xs">{text}</span>,
    },
  };

  return documentToReactComponents(content.json, options);
};

export default RichTextTable;
